import AddIcon from '@mui/icons-material/Add'
import { Button, Stack } from '@mui/material'
import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import PersonAddDialog from '@src/components/Person/PersonAddDialog'
import PersonDataTable from '@src/components/Person/PersonDataTable'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const PersonPage = () => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  function onClickAdd() {
    setOpen(true)
  }

  function onCloseAdd() {
    setOpen(false)
  }

  return (
    <>
      <PageHeader
        title={t('breadcrumbs.people')}
        breadcrumbs={{
          path: [{ href: '/people', label: t('breadcrumbs.people') }],
        }}
        actions={
          <Stack direction="row-reverse" sx={{ paddingBottom: 1 }}>
            <Button variant="contained" color="primary" onClick={onClickAdd} startIcon={<AddIcon />}>
              {t('common.add')}
            </Button>
          </Stack>
        }
      />
      <PageContainer>
        <PersonAddDialog open={open} onCloseAdd={onCloseAdd} />
        <PersonDataTable />
      </PageContainer>
    </>
  )
}

export default PersonPage
